import api from './api';
import { Branch, BranchRequest } from '../types/branch.types';

export const branchService = {
    // Get all active branches
    getAllBranches: async (): Promise<Branch[]> => {
        const response = await api.get<Branch[]>('/branches');
        return response.data;
    },

    // Get branch by ID
    getBranchById: async (id: number): Promise<Branch> => {
        const response = await api.get<Branch>(`/branches/${id}`);
        return response.data;
    },

    // Create new branch (superuser only)
    createBranch: async (request: BranchRequest): Promise<Branch> => {
        const response = await api.post<Branch>('/branches', request);
        return response.data;
    },

    // Update branch (superuser only)
    updateBranch: async (id: number, request: BranchRequest): Promise<Branch> => {
        const response = await api.put<Branch>(`/branches/${id}`, request);
        return response.data;
    },

    // Toggle branch active status (superuser only)
    toggleBranchStatus: async (id: number): Promise<Branch> => {
        const response = await api.put<Branch>(`/branches/${id}/toggle-status`);
        return response.data;
    },
};
